var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisputeAdminReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48110",
    "data-name": "Group 48110",
    transform: "translate(-1069 -336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car",
    "data-name": "Icon awesome-car",
    d: "M35.156,12.375h-4.21L29.776,9.45A7.835,7.835,0,0,0,22.465,4.5h-8.93A7.837,7.837,0,0,0,6.223,9.45l-1.17,2.925H.844a.843.843,0,0,0-.818,1.048l.422,1.688a.843.843,0,0,0,.818.639H2.678a4.469,4.469,0,0,0-1.553,3.375V22.5A4.463,4.463,0,0,0,2.25,25.448v3.8A2.25,2.25,0,0,0,4.5,31.5H6.75A2.25,2.25,0,0,0,9,29.25V27H27v2.25a2.25,2.25,0,0,0,2.25,2.25H31.5a2.25,2.25,0,0,0,2.25-2.25v-3.8A4.461,4.461,0,0,0,34.875,22.5V19.125a4.47,4.47,0,0,0-1.552-3.375h1.411a.843.843,0,0,0,.818-.639l.422-1.687a.844.844,0,0,0-.819-1.048ZM10.4,11.121A3.375,3.375,0,0,1,13.535,9h8.93A3.375,3.375,0,0,1,25.6,11.121l1.4,3.5H9l1.4-3.5ZM6.75,22.486A2.122,2.122,0,0,1,4.5,20.243,2.122,2.122,0,0,1,6.75,18c1.35,0,3.375,2.019,3.375,3.364S8.1,22.486,6.75,22.486Zm22.5,0c-1.35,0-3.375.224-3.375-1.121S27.9,18,29.25,18a2.122,2.122,0,0,1,2.25,2.243,2.122,2.122,0,0,1-2.25,2.243Z",
    transform: "translate(1076 341.5)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1253",
    "data-name": "Ellipse 1253",
    transform: "translate(1069 336)",
    fill: "none",
    stroke: "#a1a3ef",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeAdminReview);
export default __webpack_public_path__ + "static/media/DisputeAdminReview.a2e4328265e7ffb0d1e124291cadd484.svg";
export { ForwardRef as ReactComponent };